import { useEffect, useState } from 'react'

/** "Enviar outro código" libera 60 segundos depois do último pedido (o limite da API por e-mail). */
export const RESEND_AFTER_SECONDS = 60

/** Quantos segundos faltam para `deadline` (ms), contados de segundo em segundo. */
export function useSecondsUntil(deadline: number | null) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (deadline === null) return
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [deadline])
  if (deadline === null) return 0
  return Math.min(RESEND_AFTER_SECONDS, Math.max(0, Math.ceil((deadline - now) / 1000)))
}
